export default __webpack_public_path__ + "assets/models/34bffcfc89017c74719340e85b9c8f50.glb";